export class IndexCounter {
    constructor() { this.value = void 0; this.value = 0; }
    incrBy(count) { const before = this.value; this.value += count; return before; }
    next() { return this.incrBy(1); }
}
